import React from 'react';
import './style.css';
import { Grid } from 'semantic-ui-react';
const Footer = ({ user, dispatch }) => {

return (
  <div className='footer loginsignup'>
    <Grid className="full-height">
      <Grid.Row divided centered>
        <Grid.Column mobile={14} tablet={10} computer={8}>
          <div className="menucentered">
            <a key="about-us" target="_blank" href="https://videopeel.com/about-us/" className="linkprievew">About</a>
            <a key="contact" target="_blank" href=" https://videopeel.com/contact/" className="linkprievew">Contact</a>
            <a key="termsofuse" target="_blank" href="https://videopeel.com/termsofuse/" className="linkprievew">Terms</a>
            <a key="privacypolicy" target="_blank" href="https://videopeel.com/privacypolicy/" className="linkprievew">Privacy Policy</a>
          </div>
        </Grid.Column>
        <Grid.Column mobile={14} tablet={10} computer={8}>
          <p>Copyright {new Date().getFullYear()} VideoPeel All Rights Reserved</p>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </div>
);

};
export default Footer;



// WEBPACK FOOTER //
// ./src/components/Mainfooter/Footer.js